import { FormControl, FormField, FormItem } from "@/components/ui/form";
import { Select, SelectItem, SelectTrigger, SelectValue, SelectContent, SelectRemove, SelectGroup } from "@/components/ui/select";
import { cn } from "@/lib/utils";
import _ from "lodash";
import React, { useState } from "react";
import { useFormContext } from "react-hook-form";
type SelectInputProps = {
  elementId: string;
  placeholder: string | undefined | null;
  options: {
    id: string;
    text: string | undefined;
    value: string;
  }[];
  disabled?: boolean;
  isElementValid?: boolean;
  isElementTouched?: boolean;
};
function SelectInput({
  elementId,
  placeholder,
  options,
  disabled = false,
  isElementValid,
  isElementTouched
}: SelectInputProps) {
  const form = useFormContext();
  const [selectedValue, setSelectedValue] = useState<string>(_.get(form.getValues(), elementId) || "");
  const handleRemoveClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    form.setValue(elementId, "");
    setSelectedValue("");
  };
  return <FormField control={form.control} name={elementId} render={({
    field
  }) => <FormItem className={cn("relative flex rounded-md ", isElementValid && !disabled ? "border border-green-400 text-green-400" : isElementTouched ? "border border-red-400 text-red-400" : "")}>
          <Select disabled={disabled} onValueChange={newValue => {
      field.onChange(newValue);
      setSelectedValue(newValue);
    }} value={selectedValue}>
            <FormControl>
              <SelectTrigger>
                <SelectValue placeholder={placeholder ?? "Alege o optiune"} />
              </SelectTrigger>
            </FormControl>
            <SelectContent className="max-h-[200px] overflow-auto">
              <SelectGroup>
                {options.map(option => <SelectItem key={option.id} value={option.value}>
                    {option.text ?? option.value}
                  </SelectItem>)}
              </SelectGroup>
            </SelectContent>
          </Select>
          {!disabled && selectedValue && <div className="absolute right-9 top-1/2 -translate-y-1/2">
              <SelectRemove onClick={handleRemoveClick} className="absolute -bottom-1 right-0" />
            </div>}
        </FormItem>} data-sentry-element="FormField" data-sentry-component="SelectInput" data-sentry-source-file="SelectInput.tsx" />;
}
export default SelectInput;